module.exports = __webpack_public_path__ + "static/img/dd-partner-03.1ff1274.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-partner-03.jpg
// module id = Jm50
// module chunks = 1